export const addPendedReason = (pendedReason) => ({
    type: 'ADD_PENDED_REASON',
    payload: pendedReason
});